const parseQueryIESProgramFinder = (queryString) => {
  if (!queryString) {
    return [];
  }
  queryString = decodeURI(queryString);

  const query = {};
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&&');
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1].replaceAll('_', ' ') || '');
  }

  return query;
}

export default parseQueryIESProgramFinder;
